import React, { PureComponent } from 'react'
import styled from 'styled-components';
import { GlobalStyle, Colors } from 'stylecomponents';
import CupoyRouter from "components/commons/router/CupoyRouter";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import actionCreators from 'actions/creators';

const Container = GlobalStyle.BasicBlock.extend`
  width: 100%;
  margin-bottom: ${({ marginBottom }) => marginBottom ? `${GlobalStyle.ViewSpace}px` : 0};
`

const Title = styled.div`
  font-size: 16px;
  font-weight: bold;
  margin: 0px 19px 0px 20px;
`

const NavList = styled.ul`
  display: grid;
  grid-template-columns: ${props => `repeat(${props.gridNum}, auto) 1fr`};
  grid-auto-flow: column;
  justify-content: start;
  align-items: center;
  margin: 0;
  /* border-bottom: solid 1px #D9D9D9; */
`;

const NavItemTouch = styled.div`
  height: 57px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px 9px;
  color: inherit;
`;

const NavItem = styled.li`
  margin-left: 30px;
  font-size: 14px;
  cursor: pointer;
  border-bottom: 1px solid ${props => props.isActive ? Colors.MAIN_COLOR : 'transparent'};
  > div {
    border-bottom: 2px solid ${props => props.isActive ? Colors.MAIN_COLOR : 'transparent'};
  }

  ${NavItemTouch} {
      color: ${props => props.isActive ? Colors.MAIN_COLOR : '#4A4A4A'};
      font-weight: ${props => props.bold && props.isActive ? 'bold':''}
  }

  &:first-child {
    margin-left: ${props => props.marginLeft? props.marginLeft:30}px;
  }
`;

const Money = styled.div`
  /* Rectangle 5: */
  background: #F75C2F;
  border-radius: 2px;
  /* 發財金 683: */
  font-family: PingFangTC-Regular;
  font-size: 13px;
  color: #FFFFFF;
  letter-spacing: 0;
  justify-self: end;
  padding: 7px 10px;
  margin-right: ${GlobalStyle.ViewSpace}px;
`

class Navbar extends PureComponent {
  state = {
    activeIndex: 0
  }

  switchContent = activeIndex => {
    const { list, id } = this.props;
    if (list[activeIndex].stateName) {
      const stateName = list[activeIndex].stateName;
      this.props.webActions.cupoyStateGo(
        CupoyRouter.STATES[stateName],
        { id }
      );
    };
    this.setState({ activeIndex });
  }

  renderNavList = () => {
    const { list, title, money, marginLeft, bold, haslogin} = this.props;
    const { activeIndex } = this.state;
    const gridNum = list.length + 1;
    return (
      <NavList gridNum={gridNum} >
        {title && <Title>{title}</Title>}
        {list.map((li, index) => {
          return (
            <NavItem
              marginLeft={marginLeft}
              bold={bold}
              key={index}
              isActive={li.stateName?
                        CupoyRouter.isActive(CupoyRouter.STATES[li.stateName]):
                        index===activeIndex}
              onClick={() => this.switchContent(index)} >
              <NavItemTouch>{li.title}</NavItemTouch>
            </NavItem>
          )})}
        {haslogin && <Money>發財金 {money}</Money>}
      </NavList>
    )
  }

  render() {

    return (
      <React.Fragment>
        {this.props.block? 
          <Container marginBottom={this.props.marginBottom}>
            {this.renderNavList()}
          </Container>
          :this.renderNavList()}
      </React.Fragment>
    )
    
  }
}

const mapStateToProps = function (state) {
  return {
  };
};

/*--------------------------
  Reducer Action
--------------------------*/
const mapActionToProps = function (dispatch) {
  return {
    webActions: bindActionCreators(actionCreators.webActionCreators, dispatch),
  };
};

/*--------------------------
  Export
--------------------------*/
export default connect(mapStateToProps, mapActionToProps, null, {
  forwardRef: true
})(Navbar);
